import React, { useEffect, useState } from 'react';
import "./HouseKeeping.css";
import PrevColored from "../../../assets/icons/coloredPrev.svg";
import { useNavigate, useLocation } from 'react-router-dom';
import useAuth from '../../../customHooks/useAuth';
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../common/baseUrl';
import PageLoader from '../../components/PageLoader/PageLoader';
import axiosInstance from '../../../axiosInstance/axiosInstance';
import { getCurrentUser } from '../../../common/currentUser';
import { HOTEL_TIMEZONE, toHotelISO } from "../../../common/hotelTime";
import Dropdown from "../../components/Dropdown/Dropdown";


export default function HouseKeeping() {
  const navigate = useNavigate();
  const location = useLocation();

  const services = location.state?.housekeepingServices || [];
  const bookedRooms = location.state?.bookedRooms || [];
  const hotelId = location.state?.hotelId || '';
  const bookingId = location.state?.bookingId || '';
  const hotelName = location.state?.hotelName || '';
  const hotelAddress = location.state?.hotelAddress || '';
  const checkInDate = location.state?.checkInDate || "";
  const checkOutDate = location.state?.checkOutDate || "";
  const status = location.state?.status || "";
  const activeTab = location.state?.activeTab || "";
  const booking_code = location.state?.booking_code || "";


  const userId =  localStorage.getItem("user_id");

  // Use one useState hook to store all form data
  const [formData, setFormData] = useState({
    selectedService: '',
    comment: '',
    serviceDate: '',
    serviceTime: '',
    selectedRoom: ''
  });

  // State for storing validation errors
  const [errors, setErrors] = useState({});

  // Loading
  const [isLoading,setIsLoading] = useState(false);

  // Handle Refresh
  useAuth();

  // Format Date
  const formatDate = (date) => {
    return date.toLocaleDateString('en-GB', {
            timeZone: HOTEL_TIMEZONE,
      day: 'numeric',
      month: 'short',
    });
  };
  

  // Check if hotelId and bookingId are valid
  useEffect(() => {
    const checkId = () => {
      if (hotelId === "" || bookingId === "") {
        navigate("/bookings");
      }
    }
    checkId();
  }, [hotelId, bookingId, navigate]);

  const moveBack = () => {
    navigate(`/bookings/${bookingId}`);
  }

  // Validation logic for individual fields
  const validateField = (field, value) => {
    const newErrors = { ...errors };

    switch (field) {
      case "selectedService":
        if (!value.trim()) {
          newErrors.selectedService = "Service selection is required";
        } else {
          newErrors.selectedService = "";
        }
        break;
      case "serviceDate":
        if (!value.trim()) {
          newErrors.serviceDate = "Date selection is required";
        } else {
          newErrors.serviceDate = "";
        }
        break;
      case "serviceTime":
        if (!value.trim()) {
          newErrors.serviceTime = "Service time is required";
        } else {
          newErrors.serviceTime = "";
        }
        break;
      case "selectedRoom":
        if (!value.trim()) {
          newErrors.selectedRoom = "Room selection is required";
        } else {
          newErrors.selectedRoom = "";
        }
        break;

      // case "comment":
      //   if (!value.trim()) {
      //     newErrors.comment = "Comments Are Require";
      //   } else {
      //     newErrors.comment = "";
      //   }
      //   break;

      default:
        break;
    }

    setErrors(newErrors);
  };

  // Form-level validation
  const validateForm = () => {
    const newErrors = {};
    if (!formData.selectedService.trim()) {
      newErrors.selectedService = "Service selection is required";
    }
    if (!formData.serviceDate.trim()) {
      newErrors.serviceDate = "Date selection is required";
    }
    if (!formData.serviceTime.trim()) {
      newErrors.serviceTime = "Service time is required";
    }
    if (!formData.selectedRoom.trim()) {
      newErrors.selectedRoom = "Room selection is required";
    }
    // if(!formData.comment.trim()) {
    //   newErrors.comment = "Comment is required";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
 
  // Handle Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    validateField(name, value); // Validate on change
  };


  // Function to handle date selection
  const handleDateSelection = (selectedDate) => {
    setFormData((prevState) => ({
      ...prevState,
      serviceDate: selectedDate,
    }));
    validateField("serviceDate", selectedDate); // Validate date selection
  };
 

  const handleSubmit = async(e) => {
    
    try{
      e.preventDefault(); 
      // Check if form is valid
    if (!validateForm()) {
      // console.log("Form has validation errors.");
      return;
    }
    
      setIsLoading(true);
      // Combine selected date and time into ISO 8601 format
      // Get current year

      const currentYear = new Date().getFullYear();

      // Combine selected date and time into ISO 8601 format
      const selectedDate = new Date(`${formData.serviceDate} ${currentYear}`); // Add current year
      const [hours, minutes] = formData.serviceTime.split(':');

      // Set the time to the selected date
      selectedDate.setHours(hours);
      selectedDate.setMinutes(minutes);
      selectedDate.setSeconds(0);

      // Format function without converting to UTC

      // Get the formatted date-time with specified offset
      const isoDateTimeWithInd = toHotelISO(selectedDate);
      // console.log("Date with Offset: ", isoDateTimeWithInd);


      // Convert to ISO format
      // const isoDateTime = selectedDate.toISOString();

      const roomData = bookedRooms.find(item=>item.id===formData.selectedRoom);
      // console.log("Room Number : ",roomData.room_number);

      // You can add API logic here to submit the request
      const submitData = {
        housekeeping_service_id  : formData.selectedService,
        service_room : roomData.room_number,
        additional_comments : formData.comment,
        preferred_time : isoDateTimeWithInd
      }
      // console.log("Data to be Submitted : ",submitData);

 

      const currentUser = await getCurrentUser();
 
      function findMatchedRooms(bookedRooms, usersData) {
          const contact = usersData.contact;
          const matchedRooms = bookedRooms.filter((room)=>{
              // Check if guests are null or an empty array, and skip the room if true
              if (!room.guests || room.guests.length === 0) {
                  return false; // Skip this room
              }
              const matchedGuest = room.guests.find((guest)=>guest.contact===contact);
              if(matchedGuest) {
                  return true; //
              }
              else{
                  return false;
              }
          });
          return matchedRooms;
      }        

      const usersData = currentUser;  
      const matchedRooms = findMatchedRooms(bookedRooms, usersData);

      if(matchedRooms.length<=0){
        // console.log("Booking is not Present ");
        return;
      }
      // console.log("MAtched Rooms : " + matchedRooms[0].id);

 
      const response = await axiosInstance.post(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${matchedRooms[0].id}/guest-requests/post-checkin/housekeeping-request/`,submitData);

      // console.log(response);
      toast.success("HouseKeeping Request Created Successfully");
      navigate("/bookings",{state : {activeRequests : "requests"}});
    }
    catch(error){
      console.log(error);
      toast.error(error?.response?.data?.message || "Some Error Occured");
     
    }
    finally{
      setIsLoading(false);
    }
  }


  // Get today's and tomorrow's date
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  return (
    <>
      {
        isLoading && <PageLoader/>
      }
      <div className="housekeeping">
        {/* Header */}
        <div className="housekeeping-header">
          <div className="housekeeping-header-content">
            <div className="housekeeping-prevIcon">
              <img src={PrevColored} alt="" onClick={moveBack} />
            </div>
            <div className="housekeeping-header-data">
              <h6>Request for Housekeeping Service</h6>
              <p>
                Keeping your room clean and comfortable is our priority! You can easily request housekeeping services directly through our app.
              </p>
            </div>
          </div>
        </div>

        {/* Form */}
        <form className='housekeeping-form' onSubmit={handleSubmit}>
          {/* Services */}
          <div className='housekeeping-services'>
            <div className='housekeeping-service-label'>
              <h6>Select Housekeeping Service</h6>
            </div>
            <Dropdown
              name="selectedService"
              value={formData.selectedService}
              onChange={handleChange}
              placeholder="Select a service"
              options={services.map(service => ({ value: service.id, label: service.name }))}
            />
            {errors.selectedService && <span className="error-message">{errors.selectedService}</span>}
          </div>

          {/* Comments */}
          <div className='housekeeping-services'>
            <div className='housekeeping-service-label'>
              <h6>Comments</h6>
            </div>
            <textarea
              rows='4'
              cols="10"
              name="comment"
              value={formData.comment}
              onChange={handleChange}
            />
            {errors.comment && <span className="error-message">{errors.comment}</span>}
          </div>

          {/* Date of the service */}
          <div className='housekeeping-services'>
            <div className='housekeeping-service-label'>
              <h6>Date of the service</h6>
            </div>
            <div className='date-selection'>
              <div
                className={`date-box ${formData.serviceDate === formatDate(today) ? 'selected' : ''}`}
                onClick={() => handleDateSelection(formatDate(today))}
              >
                {formatDate(today)}  
              </div>
              <div
                className={`date-box ${formData.serviceDate === formatDate(tomorrow) ? 'selected' : ''}`}
                onClick={() => handleDateSelection(formatDate(tomorrow))}
              >
                {formatDate(tomorrow)}  
              </div>
            </div>
            {errors.serviceDate && <span className="error-message">{errors.serviceDate}</span>}
          </div>

          {/* When do you want the service */}
          <div className='housekeeping-services'>
            <div className='housekeeping-service-label'>
              <h6>When do you want the service</h6>
            </div>
            <input
              name="serviceTime"
              type="time"
              value={formData.serviceTime}
              onChange={handleChange}
            />
            {errors.serviceTime && <span className="error-message">{errors.serviceTime}</span>}
          </div>

          {/* Service Room */}
          <div className='housekeeping-services'>
            <div className='housekeeping-service-label'>
              <h6>Service Room</h6>
            </div>
            <div className='housekeeping-service-room'>
              <div className='housekeeping-room-select'>
                <Dropdown
                  name="selectedRoom"
                  value={formData.selectedRoom}
                  onChange={handleChange}
                  placeholder="Select a room"
                  options={bookedRooms
                    .filter(room => room.room_number)
                    .map(room => ({ value: room.id, label: String(room.room_number) }))}
                />
              </div>
              <div className='housekeeping-btn'>
                <button type="submit" style={{ width: "100%" }} disabled={formData.selectedService==="" || formData.serviceDate==="" || formData.serviceTime==="" || formData.selectedRoom==="" } >Send Request</button>
              </div>
            </div>
            {errors.selectedRoom && <span className="error-message">{errors.selectedRoom}</span>}
          </div>
        </form>
      </div>
    </>
  )
}
